// Staff State
import i18n from '@/i18n'

export default {
  staffList: [],
  staffMemberInfo: {},
  fullStaffsList: [],
  fullOutletStaffsList: [],
  staffMemberSubOutlet: [],
  allPermissionsList: {},
  genderList: [{ text: i18n.t('Male'), value: 'Male' }, { text: i18n.t('Female'), value: 'Female' }],
  maritalStatusList: [{ text: i18n.t('Single'), value: 'Single' }, { text: i18n.t('Married'), value: 'Married' }],
  staffMemberRole: [
    { text: i18n.t('Manager'), value: 'Manager' },
    { text: i18n.t('Accountant'), value: 'Accountant' },
    { text: i18n.t('Cashier'), value: 'Cashier' }
  ],
  bloodGroupsList: [
    { text: i18n.t('A+'), value: 'A+' },
    { text: i18n.t('A-'), value: 'A-' },
    { text: i18n.t('B+'), value: 'B+' },
    { text: i18n.t('B-'), value: 'B-' },
    { text: i18n.t('AB+'), value: 'AB+' },
    { text: i18n.t('AB-'), value: 'AB-' },
    { text: i18n.t('O+'), value: 'O+' },
    { text: i18n.t('O-'), value: 'O-' }
  ]
}
